/**
 * Query key factory for taxation-related queries
 * Follows the pattern used in transaction.keys.ts
 */
const scopes = {
  tss: "tss",
  tssAll: "tssAll",
  clients: "clients",
  clientAll: "clientAll",
  exports: "exports",
  dashboard: "dashboard",
  transactions: "transactions",
};

export const taxationKeys = {
  // All TSS records with optional sorting
  tssAll: {
    scope: scopes.tssAll,
    all: () => [taxationKeys.tssAll.scope] as const,
    list: (filters?: { orderBy?: string }) =>
      [taxationKeys.tssAll.scope, filters] as const,
  },

  // All Clients records with optional sorting
  clientAll: {
    scope: scopes.clientAll,
    all: () => [taxationKeys.clients.scope] as const,
    list: (filters?: { orderBy?: string }) =>
      [taxationKeys.clients.scope, filters] as const,
  },

  // Individual TSS
  tss: {
    scope: scopes.tss,
    all: () => [taxationKeys.tss.scope] as const,
    byId: (tssId: string) => [taxationKeys.tss.scope, { tssId }] as const,
  },

  // Clients
  clients: {
    scope: scopes.clients,
    all: () => [taxationKeys.clients.scope] as const,
    forTss: (tssId: string) => [taxationKeys.clients.scope, { tssId }] as const,
  },

  // Exports
  exports: {
    scope: scopes.exports,
    all: () => [taxationKeys.exports.scope] as const,
    forTss: (tssId: string) => [taxationKeys.exports.scope, { tssId }] as const,
  },

  // Dashboard stats
  dashboard: {
    scope: scopes.dashboard,
    all: () => [taxationKeys.dashboard.scope] as const,
  },

  // Transactions
  transactions: {
    scope: scopes.transactions,
    all: () => [taxationKeys.transactions.scope] as const,
    forClient: (tssId: string, clientId: string, offset?: number) =>
      [taxationKeys.transactions.scope, { tssId, clientId, offset }] as const,
  },
};
